import { render, staticRenderFns } from "./ChecklistFloatFieldModule.vue?vue&type=template&id=4f2549c5&scoped=true"
import script from "./ChecklistFloatFieldModule.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChecklistFloatFieldModule.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2549c5",
  null
  
)

export default component.exports